import React, { useEffect, useState, useCallback } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";
import {
  GeneralAdminRoutes,
  drawerWidth,
  // hasPermission,
  mainLayoutStyles,
  showNotification,
} from "../../../../../constants";

import {
  AdminsUserTable,
  FilterSection,
  SearchBar,
} from "../../components/components";
import { useNavigate } from "react-router-dom";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import Header from "../../../../../common/Header";
import { useAdminsContext } from "../../../../../providers/OrganizationAdmin/AdminsProvider";
import { getFilterGAAdminUsers, usersSearch } from "../../hooks/GAAdminHooks";
import {
  deleteUserAuth,
  disableUserFunction,
  enableUserFunction,
} from "../../../../../firebase";
import {
  deleteAdmin,
  updateAdmin,
} from "../../../../../modules/Admins/hooks/AdminsHook";
import { Toast } from "../../../../../common/alert";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";
import { useAuth } from "../../../../../hooks";

const AdminUsersContainer = () => {
  const { currentUser } = useAuth();
  const { GAAdmins, handleGetGAAdmins, setLoading, loading } =
    useAdminsContext();

  const navigate = useNavigate();
  const [allAdminUsers, setAllAdminUsers] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [roleFilterOptions, setRoleFilterOptions] = useState([]);
  const [dateAddedFilterOptions, setDateAddedFilterOptions] = useState([]);
  const [lastLoginDateFilterOptions, setLastLoginDateFilterOptions] = useState(
    []
  );

  useEffect(() => {
    // if (GAAdmins?.length) {
    // } else {
    handleGetGAAdmins();
    setStatusFilterOptions(["active"]); // Initialize with active selected
    // }
  }, []);


  // console.log("Admin Users:", GAAdmins);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  const handleSearchAdmins = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let adminsSearchTemp = await usersSearch(GAAdmins, value);
        console.log("searched:", adminsSearchTemp);
        setAllAdminUsers(adminsSearchTemp);
      } else {
        // setAllAdminUsers(GAAdmins);
        const filteredAdmins = GAAdmins.filter(
          (admin) => admin.status !== "inactive"
        );
        setAllAdminUsers(filteredAdmins);
      }
    } catch (error) {
      console.log("error searching admin users:", error.message);
    }
  };

  const handleDeleteAdmin = async () => {
    try {
      setLoading(true);
      const selectedUsersDetails = GAAdmins.filter((user) =>
        selected.includes(user.id)
      ).map((userRecord) => userRecord);

      for (const userData of selectedUsersDetails) {
        if (currentUser?.role === "super") {
          await deleteUserAuth({ text: userData.userId });
          await deleteAdmin(userData.id);
          showNotification("Admin Deleted successfully.");
        } else {
          if (currentUser?.role === "manager") {
            if (
              userData?.role === "standard" ||
              userData?.role === "moderator"
            ) {
              await deleteUserAuth({ text: userData.userId });
              await deleteAdmin(userData.id);
              showNotification("Admin Deleted successfully.");
            } else {
              showNotification(
                `You don't have the permissions to delete ${
                  userData?.firstName + " " + userData?.lastName
                }`
              );
            }
          } else
            showNotification(
              `You don't have the permissions to delete ${
                userData?.firstName + " " + userData?.lastName
              }`
            );
        }
      }
      // selected.forEach(async (item) => {
      //   await deleteUserAuth({ text: item.userId });
      //   await deleteAdmin(item.id);
      // });
      await handleGetGAAdmins();
      setSelected([]);
      // Toast("success", "Admin Deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting admin:", error.message);
    } finally {
      handleDeleteModalClose();
      setLoading(false);
    }
  };

  const handleUpdateAdminStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
        updatedAt: new Date(),
      };
      const selectedUsersDetails = GAAdmins.filter((user) =>
        selected.includes(user.id)
      ).map((userRecord) => userRecord);

      for (const userData of selectedUsersDetails) {
        if (currentUser?.role === "super") {
          if (status === "inactive") {
            const result = await disableUserFunction({ uid: userData.id });
          }
          if (status === "active") {
            const result = await enableUserFunction({ uid: userData.id });
          }
          let responseTemp = await updateAdmin(userData.id, dataTemp);
          console.log("update admin response:", responseTemp);
          showNotification("Admin updated successfully.");
        } else {
          if (currentUser?.role === "manager") {
            if (
              userData?.role === "standard" ||
              userData?.role === "moderator"
            ) {
              if (status === "inactive") {
                const result = await disableUserFunction({ uid: userData.id });
              }
              if (status === "active") {
                const result = await enableUserFunction({ uid: userData.id });
              }
              let responseTemp = await updateAdmin(userData.id, dataTemp);
              console.log("update admin response:", responseTemp);
              showNotification("Admin updated successfully.");
            } else {
              showNotification(
                `You don't have the permissions to update ${
                  userData?.firstName + " " + userData?.lastName
                }`
              );
            }
          } else
            showNotification(
              `You don't have the permissions to update ${
                userData?.firstName + " " + userData?.lastName
              }`
            );
        }
      }
      // selected.forEach(async (item) => {
      //   let responseTemp = await updateAdmin(item, dataTemp);
      //   console.log("update admin response:", responseTemp);
      // });
      await handleGetGAAdmins();
      setSelected([]);
      // showNotification("Admin status updated successfully.");
      // Toast("success", "admin status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating admin status", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterAdminUsers = useCallback(async () => {
    console.log("=== handleFilterAdminUsers called ===");
    console.log("statusFilterOptions:", statusFilterOptions);
    console.log("roleFilterOptions:", roleFilterOptions);
    console.log("dateAddedFilterOptions:", dateAddedFilterOptions);
    console.log("lastLoginDateFilterOptions:", lastLoginDateFilterOptions);
    console.log("GAAdmins count:", GAAdmins?.length);
    
    let dateAddedRange;
    let lastLogindateRange;
    if (dateAddedFilterOptions && dateAddedFilterOptions.length > 0) {
      dateAddedRange = getDateRange(dateAddedFilterOptions, "Date Added");
    }
    if (lastLoginDateFilterOptions && lastLoginDateFilterOptions.length > 0) {
      lastLogindateRange = getDateRange(
        lastLoginDateFilterOptions,
        "Last Login"
      );
    }
    setSelected([]);

    if (
      statusFilterOptions.length > 0 ||
      roleFilterOptions.length > 0 ||
      dateAddedFilterOptions.length > 0 ||
      lastLoginDateFilterOptions.length > 0
    ) {
      console.log(">>> Calling getFilterGAAdminUsers with filters");
      let temp = await getFilterGAAdminUsers(
        statusFilterOptions,
        roleFilterOptions,
        // dateAddedFilterOptions,
        // lastLoginDateFilterOptions,
        dateAddedRange,
        lastLogindateRange,
        setLoading,
        handleFilterModalClose
      );
      console.log(">>> Filtered result count:", temp?.length);
      setAllAdminUsers(temp);
    }
    if (
      statusFilterOptions.length === 0 &&
      roleFilterOptions.length === 0 &&
      dateAddedFilterOptions.length === 0 &&
      lastLoginDateFilterOptions.length === 0
    ) {
      console.log(">>> No filters selected, showing all GAAdmins");
      console.log(">>> Setting allAdminUsers to GAAdmins, count:", GAAdmins?.length);
      setAllAdminUsers(GAAdmins);
    }
    console.log("=== handleFilterAdminUsers complete ===");
  }, [
    statusFilterOptions,
    roleFilterOptions,
    dateAddedFilterOptions,
    lastLoginDateFilterOptions,
    GAAdmins,
  ]);

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "role") {
      setRoleFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "lastLoginDate") {
      setLastLoginDateFilterOptions([]);
      // setLastLoginDateFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    } else if (filterType === "dateAdded") {
      setDateAddedFilterOptions([]);
      // setDateAddedFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    }
  };

  useEffect(() => {
    handleFilterAdminUsers();
  }, [handleFilterAdminUsers]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const resetFilter = async () => {
    setStatusFilterOptions([]);
    setDateAddedFilterOptions([]);
    setLastLoginDateFilterOptions([]);
    setRoleFilterOptions([]);
    // Show all admins when filter is reset
    setAllAdminUsers(GAAdmins);
    setSelected([]);
    handleFilterModalClose();
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header
        mainTitle={"Admin Users"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super" || currentUser?.role === "manager"
            ? "Add User"
            : undefined
        }
        handleSubmit={() => navigate(GeneralAdminRoutes.addAdminUser)}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            roleFilterOptions={roleFilterOptions}
            dateAddedFilterOptions={dateAddedFilterOptions}
            lastLoginDateFilterOptions={lastLoginDateFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            placeholder={"Search"}
            selected={selected}
            setSelected={setSelected}
            handleSearch={handleSearchAdmins}
            handleDeleteAdmin={handleDeleteModalOpen}
            handleUpdateAdminStatus={handleUpdateAdminStatus}
          />

          <AdminsUserTable
            selected={selected}
            setSelected={setSelected}
            allAdminUsers={allAdminUsers}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteAdmin}
        loading={loading}
        title={"Are you sure to delete the selected Admin(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={() => {
          // Delay to allow state updates to complete
          //setTimeout(() => handleFilterAdminUsers(), 0);
        }}
        data={[
          // {
          //   mainOptions: dateAddedFilterOptions,
          //   setMainOptions: setDateAddedFilterOptions,
          //   type: "date",
          //   title: "Date Added",
          //   currentOptions: [
          //     { label: "All", selected: true },
          //     { label: "Today", selected: false },
          //     { label: "Past Week", selected: false },
          //     { label: "Last 30 Days", selected: false },
          //     { label: "Last 12 Months", selected: false },
          //     { label: "Enter a Range", selected: false },
          //   ],
          // },
          {
            mainOptions: dateAddedFilterOptions,
            setMainOptions: setDateAddedFilterOptions,
            type: "date",
            title: "Date Added",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "active", selected: false },
              { label: "inactive", selected: false },
              { label: "invited", selected: false },
            ],
          },
          {
            mainOptions: roleFilterOptions,
            setMainOptions: setRoleFilterOptions,
            type: "text",
            title: "Role",
            currentOptions: [
              { label: "All", selected: true },
              { label: "super", selected: false },
              { label: "manager", selected: false },
              { label: "standard", selected: false },
              { label: "moderator", selected: false },
            ],
          },
          {
            mainOptions: lastLoginDateFilterOptions,
            setMainOptions: setLastLoginDateFilterOptions,
            type: "date",
            title: "Last Login",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AdminUsersContainer;
